<template>
  <article>
    <group gutter="0px" class="status">
      <cell title="客户姓名" :value="customer.customer_name"></cell>
      <cell title="联系电话" :value="customer.mobile"></cell>
    </group>
    <group title="到店信息" class="status">
      <cell title="首次到店类型" :value="getArriveTypeValue(customer.first_arrive_type)"></cell>
      <cell title="首次到店日期" :value="timeTransform(customer.first_arrive_at)"></cell>
      <cell title="意向级别" :value="getLevelValue(customer.intention_level)+'级'"></cell>
      <cell title="购车意向" primary="content" class="status-left status-cell">
        <div slot="value" class="status-cell-group">
          <cell
              v-for="(item,index) in customer.intention_cars" :key="index"
              :title="item.car_model_name+'-'+item.inner_color_ch+'-'+item.outer_color_ch" class="car-intention">
          </cell>
        </div>
      </cell>
      <cell title="竞品车型" primary="content" class="status-left status-cell">
        <div slot="value" class="status-cell-group"><!--最多三个-->
          <cell v-for="(item,index) in customer.contrast_cars" :key="index"
                :title="item.car_model_name" class="car-intention">
          </cell>
        </div>
      </cell>
      <cell title="客户渠道" :value="getChannelValue(customer.channel_type,customer.sub_channel_type)"></cell>
      <cell title="地区来源" :value="getArea(customer.province,customer.city,customer.district)"></cell>
      <cell title="详细地址" :value="customer.address"></cell>
    </group>
    <group class="status">
      <cell title="建档人员" :value="customer.creator"></cell>
    </group>
    <group title="跟进记录" v-if="customer.notes.length>0">
      <cell class="sale-record" v-for="(item, index) in customer.notes" :key="index">
        <p slot="after-title"><span class="label">{{item.intention_level}}级</span></p>
        <p slot="after-title" class="content">{{item.remark}}</p>
        <p slot="after-title" class="time">{{item.created_at}}<span class="call-time">通话时长：{{item.call_duration}}</span>
        </p>
      </cell>
    </group>
    <section class="btn-bottom" v-if="btnShow">
      <div class="btn-fix">
        <a class="btn" href="javascript:void(0);" @click.stop="associateCustomer()">确认关联</a>
      </div>
    </section>
  </article>
</template>

<script>
import {
  Cell,
  Group
} from '@lx-frontend/cvux'

export default {
  components: {
    Cell,
    Group
  },
  data () {
    return {
      id: '',
      store_visit_id: '',
      btnShow: true,
      arrive_type: [],
      intention_level: [],
      car_color: [],
      channelTypeArr: [],
      subChannelTypeArr: [],
      customer: {
        notes: []
      }
    }
  },
  created () {
    this.id = this.$route.params.id
    this.store_visit_id = this.$route.query.store_visit_id
    if (!this.store_visit_id) {
      this.btnShow = false
    }
    if (this.id) {
      this.$rest.saleManage.getEnums().then(res => {
        if (res.code === 0) {
          let data = res.data
          this.arrive_type = data.arrive_type
          this.intention_level = data.intention_level
          this.car_color = data.car_color
          this.channelTypeArr = res.data.channel_type
          this.subChannelTypeArr = res.data.sub_channel_type
        }
      }).then(() => {
        this.$rest.saleManage.arrivedCustomerInfo(null, this.id).then(res => {
          if (res.code === 0) {
            this.customer = res.data
            this.customer.intention_cars = this.customer.intention_cars.map(v => {
              v.inner_color_ch = this.car_color.find(t => {
                return v.inner_color === parseInt(t.key)
              }).value
              v.outer_color_ch = this.car_color.find(t => {
                return v.outer_color === parseInt(t.key)
              }).value
              return v
            })
            let channelT = this.customer.channel_type
            if (channelT > 0) {
              let subChannelT = this.customer.sub_channel_type
              subChannelT = channelT === 1 ? `100${subChannelT}` : `${channelT}${channelT}`
              this.chanelList = [channelT + '', subChannelT]
            } else {
              this.chanelList = []
            }
          }
        })
      })
    }
  },
  methods: {
    timeTransform (str) {
      if (!str) return ''
      let date = new Date(str.replace(/-/g, '/'))
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      return year + '-' + month + '-' + day
    },
    getChanelType (list, subList) {
      let listArr = []
      list.forEach(v => {
        listArr.push({
          name: v.value,
          value: v.key
        })
      })
      list.forEach(v => {
        if (v.value === '网络渠道') {
          subList.forEach(j => {
            listArr.push({
              name: j.value,
              value: `${v.key}00${j.key}`,
              parent: v.key
            })
          })
          listArr.push({
            name: '--',
            value: `${v.key}000`,
            parent: v.key
          })
        } else {
          listArr.push({
            name: '--',
            value: v.key + v.key,
            parent: v.key
          })
        }
      })
      return listArr
    },
    getArriveTypeValue (firstArriveType) {
      if (!firstArriveType) return ''
      let item = this.arrive_type.find(v => {
        return parseInt(v.key) === firstArriveType
      })
      if (item) {
        return item.value
      }
    },
    getLevelValue (level) {
      if (!level) return ''
      let item = this.intention_level.find(v => {
        return parseInt(v.key) === level
      })
      if (item) {
        return item.value
      }
    },
    getChannelValue (channelType, subChannelType) {
      if (!channelType) return ''
      let str = ''
      let channel = this.channelTypeArr.find(v => {
        return parseInt(v.key) === channelType
      })
      if (channel) {
        str = channel.value
      }
      let subChannel = this.subChannelTypeArr.find(t => {
        return parseInt(t.key) === subChannelType
      })
      if (subChannel) {
        str += '-' + subChannel.value
      }
      return str
    },
    getArea (province, city, district) {
      if (!province || !city) return ''
      let str = province + '-' + city
      if (district) {
        str += '-' + district
      }
      return str
    },
    associateCustomer () {
      if (this.id && this.store_visit_id) {
        this.$rest.saleManage.associateCustomer({
          customer_id: parseInt(this.id),
          store_visit_id: parseInt(this.store_visit_id)
        }).then(res => {
          if (res.code === 0) {
            this.showToast('关联成功')
            this.btnShow = false
            this.$router.push('/salemanage/staff/visitors')
          } else {
            this.showToast(res.message)
          }
        })
      }
    }
  }
}
</script>
<style lang="less">
   @import "../../../stylesheets/modules/salemanage/sale";
</style>
